export default function (theme) {
    return {
        MuiSpeedDialAction: {
            styleOverrides: {
                fab: {
                    color: theme.palette.secondary.dark
                },
                staticTooltipLabel: {
                    color: '#fff',
                    backgroundColor: 'rgba(97, 97, 97, 0.9)',
                    padding: [[4, 8]],
                    maxWidth: 300,
                    wordWrap: 'break-word',
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: '1.4em',
                    borderRadius: 4,
                    margin: [[0, 14]],
                    whiteSpace: 'nowrap'
                }

            }
        },
        MuiSpeedDial: {
            styleOverrides: {
                actions: {
                    marginLeft: '45%'
                }
            }
        }
    };
}
